import { createFileRoute, redirect } from '@tanstack/react-router';
import { API_ROUTES, CUSTOMER_DATA_TABS } from 'cpool-constants';

import { ROLES } from '~/constants';
import { authoriseUser } from '~/features/auth/utils/authoriseUser';
import LeadHistory from '~/features/leadDetails/components/History';
import { CUSTOMER_DATA_TAB_PATHS } from '~/features/leadDetails/constants/tabPaths';
import { aclPermissionsQueryOptions } from '~/features/leadDetails/routes/acceptedOffersQueryOptions';

export const Route = createFileRoute('/_app/leads_/details/$leadId/history')({
    beforeLoad: async ({ context, location, params }) => {
        authoriseUser(Object.values(ROLES), location);
        const permissions = await context.queryClient.ensureQueryData(aclPermissionsQueryOptions(params.leadId));
        // /events 403s would otherwise end up on /accessdenied
        if (!permissions.api[API_ROUTES.events])
            throw redirect({
                params: {
                    customerTab: CUSTOMER_DATA_TAB_PATHS[CUSTOMER_DATA_TABS.PERSONAL_DATA],
                    leadId: params.leadId,
                },
                replace: true,
                to: '/leads/details/$leadId/customer-data/$customerTab',
            });
    },
    component: () => <LeadHistory />,
});
